import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import printConfig from '../../../print-config.json';
import getPeriodeEndDate from '../../../functions/getPeriodeEndDate';
import getData from '../../../functions/getData';
import toJS from '../../../hoc/toJS';
import { THEME, PROGRAM_CLI_MOVIES_ITEMS, LOGO, PROGRAM_CINEMAS, CLI_CURRENT_CINEMA_ID, PROGRAM_PERFORMANCES, TRANSLATION, PROGRAM_ATTRIBUTES, CLI_CINEMA_CLIENT_ID, CLI_MULTICINEMA_MODE, FEATURES } from '../../../constants/state';
import FlyerHeightContainer from './FlyerHeightContainer';
import FlyerPreview from '../presents/FlyerPreview';
import getFormatedDate from '../../../functions/getFormatedDate';
import { Component } from 'react';
import getOptionalCinemaId from '../../../functions/cinemaAndTimeRangeFilters/getOptionalCinemaId';
import filterAttributesByCinema from '../../../functions/cinemaAndTimeRangeFilters/filterAttributesByCinema';
import sortAlphabetical from '../func/sortAlphabetical';



const mapStateToProps = state => ({
    colors: getData(state, THEME),
    movies: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    performances: getData(state, PROGRAM_PERFORMANCES),
    attributes: getData(state, PROGRAM_ATTRIBUTES),
    logoData: getData(state, LOGO),
    hasFylerCaption: getData(state, [FEATURES, 'has_flyer_caption']),
    cinemas: getData(state, PROGRAM_CINEMAS),
    cinemaId: getData(state, CLI_CURRENT_CINEMA_ID),

    currentClientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),

    translation: getData(state, TRANSLATION)
})


class FlyerPreviewContainer extends Component {
    constructor(props) {
        super(props)
    }

    getDates() {
        const { activeWeek } = this.props

        const year = new Date().getFullYear()
        const currentWeek = new Date(year, 0, (1 + (activeWeek - 1) * 7));
        
        while (currentWeek.getDay() !== 4) {
            currentWeek.setDate(currentWeek.getDate() + 1);
        }

        const currentPeriodeStartDate = currentWeek
        const currentPeriodeEndDate = getPeriodeEndDate(currentWeek)

        return {
            currentPeriodeStartDate: currentPeriodeStartDate,
            currentPeriodeEndDate:  currentPeriodeEndDate,
            formartedCurrentPeriodeStartDate:  getFormatedDate(currentPeriodeStartDate) + year,
            formartedCurrentPeriodeEndDate:  getFormatedDate(currentPeriodeEndDate) + year
        }
    }

    getStyles() {
        const { printFormat, landscape, colors } = this.props
        const { accent_color_background, flyer_background } = colors

        const currentPrintFormat = _.findWhere(printConfig.formats, {path: printFormat, landscape: landscape})
        const currentPrintID = _.findKey(printConfig.formats, currentPrintFormat)
        const format = printConfig.formats[currentPrintID]

        let styles = {
            height: format.height,
            backgroundColor: accent_color_background,
        }
    
        if(flyer_background) {
            styles = {
                height: format.height,
                backgroundImage: `url(${flyer_background.url})`
            }
        }

        return {
            styles: styles
        }
    }

    getAttributes() {
        const { multicinemaMode, currentClientCinemaId, currentCinemaId, attributes } = this.props

        const optionalCinemaId = getOptionalCinemaId(multicinemaMode, currentCinemaId, currentClientCinemaId)
        const filteredAttributes = filterAttributesByCinema(attributes, optionalCinemaId)
        const sortedAttributes = sortAlphabetical(_.keys(filteredAttributes.technical))
        const captionAttributes = {}
        
        
        filteredAttributes && sortedAttributes && sortedAttributes.map((attributeId, index) => {
            const currentAlphabetNumber = (index + 10).toString(36).toUpperCase()
            const { name } = filteredAttributes.technical[attributeId]    
            
            if(name !== 'blocksubscriptions') {
                captionAttributes[attributeId] = {
                    captionLetter: currentAlphabetNumber,
                    captionName: name,
                    id: attributeId
                }
            }
        })


        return {
            captionAttributes: captionAttributes
        }
    }


    render() {
        const { activeWeek, side, section, currentCinemaId, translation, flyerData, colors, movies, performances, logoData, hasFylerCaption, cinemas, hideAttributes } = this.props
        const { currentPeriodeStartDate, currentPeriodeEndDate, formartedCurrentPeriodeStartDate, formartedCurrentPeriodeEndDate } = this.getDates()
        const { styles } = this.getStyles()
        const { captionAttributes } = this.getAttributes()

        const cinemaData = cinemas[currentCinemaId]
        const items = flyerData.flyerStructure[side][section]

        return (
            <FlyerHeightContainer side={side} section={section} flyerData={flyerData}>
                <FlyerPreview
                    styles={styles}
                    side={side} 
                    hideAttributes={hideAttributes} 
                    section={section}
                    movies={movies}
                    performances={performances}
                    translation={translation}
                    currentCinemaId={currentCinemaId}
                    cinemaData={cinemaData}
                    flyerData={flyerData}
                    captionAttributes={captionAttributes}
                    colors={colors}
                    iconsColor='light'
                    hasFylerCaption={hasFylerCaption}
                    currentPeriodeStartDate={currentPeriodeStartDate}
                    currentPeriodeEndDate={currentPeriodeEndDate}
                    formartedCurrentPeriodeStartDate={formartedCurrentPeriodeStartDate}
                    formartedCurrentPeriodeEndDate={formartedCurrentPeriodeEndDate}
                    items={items}
                    week={activeWeek}
                    logoData={logoData}
                />
            </FlyerHeightContainer>
        )
    }
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(FlyerPreviewContainer)